import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import { PaziaButton, PaziaTextarea, RatingStars } from "components/atoms";
import { UserExamAnswerApi } from "api/userExamsApi";
import { ReviewAnswerPayload } from "./store/reducer";

interface RatingPanelFormProps {
  answer: UserExamAnswerApi;
  onSubmit: (values: ReviewAnswerPayload) => Promise<void>;
  hidden?: boolean;
}
export const RatingPanelForm = ({ onSubmit, answer, hidden }: RatingPanelFormProps) => {
  const [visibleStars, setVisibleStars] = React.useState(false);
  const methods = useForm<RatingFromValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      [RATING_FORM_NAMES.USER_EXAM_ANSWER_ID]: answer.userExamAnswerId,
      [RATING_FORM_NAMES.COMMENT]: answer.review?.comment,
    },
  });
  const { getValues } = methods;

  const onPointsSelected = (points: number) => {
    const values = getValues();
    onSubmit({ ...values, points, passed: null });
  };

  const onCorrectClick = () => {
    onSubmit({ ...getValues(), passed: true, points: null });
  };

  const onIncorrectClick = () => {
    onSubmit({ ...getValues(), passed: false, points: null });
  };

  return (
    <FormProvider {...methods}>
      <form className={`grid gap-3 ${hidden ? "hidden" : ""}`}>
        <PaziaTextarea name={RATING_FORM_NAMES.COMMENT} label="Komentarz" />
        <label className="block text-sm font-medium mb-1 truncate">Ocena</label>
        <div className="flex justify-between">
          <div className="w-1/3">
            <PaziaButton
              btnType="button"
              type="danger2"
              title="Błędna"
              className="w-[120px]"
              onClick={onIncorrectClick}
            />
          </div>
          <div className="w-1/3 flex items-center flex-col">
            <PaziaButton
              btnType="button"
              type="tertiary"
              title="Skala oceny"
              className="w-[120px]"
              onClick={() => setVisibleStars((p) => !p)}
            />
            {visibleStars && <RatingStars lowerLabel="" upperLabel="" onSelect={onPointsSelected} />}
          </div>
          <div className="w-1/3 flex justify-end">
            <PaziaButton
              btnType="button"
              type="success2"
              title="Poprawna"
              className="w-[120px]"
              onClick={onCorrectClick}
            />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

const RATING_FORM_NAMES = {
  COMMENT: "comment",
  USER_EXAM_ANSWER_ID: "userExamAnswerId",
} as const;

const schema = yup
  .object({
    [RATING_FORM_NAMES.USER_EXAM_ANSWER_ID]: yup.number().required(),
    [RATING_FORM_NAMES.COMMENT]: yup.string(),
  })
  .required();

export type RatingFromValues = yup.InferType<typeof schema>;
